import React, { useState, useEffect} from 'react'
import { connect } from 'react-redux';


import { getGroupCode5, getOPK, postOPK, putOPK, deleteOPK, getCalcSettings, putCalcSettings } from 'actions/opkEdit'
// reactstrap components
import {
    Row,
    Col, Form, FormGroup, Input, Button,
    UncontrolledTooltip,

} from "reactstrap";

// components
import OPKForm from './OPKForm'
import PaginationButtons from 'components/common/PaginationButtons'

const MainOPK = ({
    GetOpk:{group_code_5, opk_list, loading, calc_settings, calc_settings_loading},
    getGroupCode5, getOPK, putOPK, postOPK, deleteOPK, getCalcSettings, putCalcSettings,
    notify, currentUser}) => {
            const [PageActiveItem, setPageActiveItem] = useState(1)

    //Form fields for add opk
    const defValues = {group_id:"", resort_code:"",own_code:"",opk_type:"podstawowy", opk_number:"", resort_name:"", cost_type: "stale", duration_calc: false}
    const [formValues,setFormValues]=useState(defValues)
    const [opk_type_filter,setOpkTypeFilter]=useState('')
    const [calc_settings_select,setCalcSettings]=useState('')

    useEffect(() => {
        getGroupCode5()
        getCalcSettings()
        // eslint-disable-next-line
    }, [])
    useEffect(() => {
        getOPK({page:PageActiveItem, opk_type: opk_type_filter})
        if(document.getElementById('top-pagination')) document.getElementById('top-pagination').scrollIntoView();
    }, [PageActiveItem, opk_type_filter])
    useEffect(() => {
        if(Object.getOwnPropertyNames(calc_settings).length !== 0){
            setCalcSettings(calc_settings.management_cost_settings)
        }
    }, [calc_settings])
    useEffect(() => {
        if(!calc_settings_loading){
            notify('Zmieniono ustawienia rozliczenia kosztów zarządu', 'info')
        }
    }, [calc_settings_loading])
    const saveClcSettings = () => {
        let id = calc_settings.id
        let data = calc_settings
        data.management_cost_settings = calc_settings_select
        putCalcSettings(id, data)
    }

    const handleSubmit = () => {
        let errorMessage = []
        //validation
        if(errorMessage.length!==0){
            notify(errorMessage.join(' '))
        }else{
            postOPK(formValues)
            setFormValues(defValues)
        }
    }

    //build opk numer to display
    useEffect(() => {
        let new_opk_number='';
        let firstPart="" ;

        if(group_code_5.length > 0 && formValues.group_id!='')
           firstPart = group_code_5.filter(opk=>opk.id==formValues.group_id)[0];

        if(firstPart!=="" && firstPart && firstPart.hasOwnProperty("group_number"))
            new_opk_number = firstPart.group_number+"-"
        else
            new_opk_number = ''

        if(formValues.own_code!=="")
            new_opk_number = new_opk_number  + formValues.resort_code +"-"
        else
            new_opk_number = new_opk_number + formValues.resort_code

        new_opk_number=new_opk_number+formValues.own_code

         setFormValues((prevState) => {
            let newState = { ...prevState };
            newState["opk_number"] = new_opk_number
            return(newState)
        })

    },[formValues.group_id,formValues.own_code,formValues.resort_code])

    const handleFieldChange = (e) => {
        const itemID = parseInt(e.target.id.split('-')[1])
        const itemName = e.target.id.split('-')[0]
        const itemValue = e.target.value
        setFormValues((prevState) => {
            let newState = { ...prevState };
            newState[itemName] = itemValue
            return(newState)
        })
    }

    const showChangeClcSettings = () => {
       if(currentUser!==null) return opk_type_filter==='zarząd'&& currentUser.is_company_creator
       else return false
    }

    return (
        <>
            <div className={'form-fields-container'} style={{margin: '0 15px'}}>
                <Row className={'row-margin'} style={{alignItems: 'flex-end'}} >
                    <Col sm={5}>
                        <Row className={' text-center'}  style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}} >
                            <Col sm={3}> Kod syntetyczny </Col>
                            <Col sm={3}> Kod resortowy </Col>
                            <Col sm={3}> Kod własny </Col>
                            <Col sm={3}> Typ OPK </Col>
                        </Row>
                    </Col>
                    <Col sm={7}>
                        <Row className={' text-center'} style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}} >
                            <Col sm={3}> Numer OPK </Col>
                            <Col sm={formValues.opk_type!=='zarząd'?6:8}> Nazwa OPK </Col>
                            {formValues.opk_type!=='zarząd'&&<Col sm={2}>
                                { formValues.opk_type==='proceduralny'? <>Typ rozliczenia kosztów</>:<> Rodzaj kosztów </> }
                            </Col>}
                            <Col sm={1}> Dodaj </Col>
                        </Row>
                    </Col>
                </Row>
                <Form key={"add_opk"} id={"add_opk"} className='okraglaczki'>
                    <Row className={'row-margin'}>
                        <Col sm={5}>
                            <Row className={''}>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`group_id-add`} className='sr-only'>Kod syntetyczny</label>
                                        <Input
                                        value={formValues.group_id}
                                        type="select"
                                        name="select"
                                        placeholder={"Wybierz"}
                                        id={`group_id-add`}
                                        onChange={(e) => handleFieldChange(e)}
                                        >
                                            <option value={''}> Wybierz...</option>
                                            {group_code_5.sort((first, second)=> {
                                                        return first.group_number - second.group_number;
                                                        }).map((groupCodeItem, codeIdx )=>{
                                                return(
                                                    <option key={codeIdx} value={groupCodeItem.id}>
                                                        {`${groupCodeItem.group_number}`}
                                                    </option>
                                                )
                                            })}

                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`resort_code-add`} className='sr-only'>Kod resortowy</label>
                                        <Input
                                            value={formValues.resort_code}
                                            id={`resort_code-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`own_code-add`} className='sr-only'>Kod własny</label>
                                        <Input
                                            value={formValues.own_code}
                                            id={`own_code-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`opk_type-add`} className='sr-only'>Typ OPK</label>
                                        <Input
                                            value={formValues.opk_type}
                                            type="select"
                                            name="select"
                                            id={`opk_type-add`}
                                            onChange={(e) => handleFieldChange(e)}
                                        >
                                            <option value={"podstawowy"}>podstawowy</option>
                                            <option value={"proceduralny"}>proceduralny</option>
                                            <option value={"pomocniczy medyczny"}>pomocniczy medyczny</option>
                                            <option value={"pomocniczy niemedyczny"}>pomocniczy niemedyczny</option>
                                            <option value={"zarząd"}>zarząd</option>
                                        </Input>
                                    </FormGroup>
                                    <UncontrolledTooltip
                                        delay={0}
                                        placement="bottom"
                                        target={`opk_type-add`}
                                    >
                                        {formValues.opk_type}
                                    </UncontrolledTooltip>
                                </Col>
                            </Row>
                        </Col>

                        <Col sm={7}>
                            <Row className={'row-margin'}>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor={`opk_number-add`} className='sr-only'>Numer OPK</label>
                                        <Input
                                            value={formValues.opk_number}
                                            id={`opk_number-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={formValues.opk_type!=='zarząd'?6:8}>
                                    <FormGroup>
                                        <label htmlFor={`resort_name-add`} className='sr-only'>Nazwa OPK</label>
                                        <Input
                                            value={formValues.resort_name}
                                            id={`resort_name-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                {formValues.opk_type!=='zarząd'&&<Col sm={2}>
                                    { formValues.opk_type==='proceduralny'?
                                        <FormGroup>
                                            <label htmlFor={`duration_calc-add`} className='sr-only'>Typ rozliczenia kosztów</label>
                                            <Input
                                                value={formValues.duration_calc}
                                                type="select"
                                                name="select"
                                                id={`duration_calc-add`}
                                                onChange={(e) => handleFieldChange(e)}
                                            >
                                                <option value={false}>w oparciu o jednostkę kalkulacyjną</option>
                                                <option value={true}>proporcjonalnie do czasu trwania procedur medycznych</option>
                                            </Input>
                                            {/* <UncontrolledTooltip
                                                delay={0}
                                                placement="bottom"
                                                target={`duration_calc-add`}
                                            >
                                                {formValues.duration_calc? <>proporcjonalnie do czasu trwania procedur medycznych</>: <>w oparciu o jednostkę kalkulacyjną</>}
                                            </UncontrolledTooltip> */}
                                        </FormGroup>:
                                        <FormGroup>
                                            <label htmlFor={`cost_type-add`} className='sr-only'>Rodzaj kosztów</label>
                                            <Input
                                                value={formValues.cost_type}
                                                type="select"
                                                name="select"
                                                id={`cost_type-add`}
                                                onChange={(e) => handleFieldChange(e)}
                                            >
                                                <option value={"stale"}>stałe</option>
                                                <option value={"zmienne"}>zmienne</option>
                                            </Input>
                                        </FormGroup>
                                    }
                                </Col>}
                                <Col sm={1}>
                                    <Row className={'text-center'}>
                                        <Col>
                                        <Button
                                            className="btn btn-round mr-1" outline
                                            color="import"
                                            data-toggle="tooltip"
                                            id={`save`}
                                            // size="sm"
                                            style={{marginTop:"0px", width:"60px"}}
                                            type="button"
                                            onClick={(e) => handleSubmit(e)}
                                            disabled={currentUser && currentUser.company === null}
                                            aria-label='Dodaj konto'

                                        >
                                             <i className='nc-icon nc-simple-add'></i>
                                            {/* <i className="far fa-plus-square fa-2x"></i> */}
                                        </Button>
                                        <UncontrolledTooltip
                                            delay={0}
                                            placement="top"
                                            target={`save`}
                                        >
                                            Dodaj konto
                                        </UncontrolledTooltip>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </div>
            <hr/>
            <div className='form-fields-container' id='top-pagination'>

                {!loading && opk_list.results ?
                    <>
                        <PaginationButtons
                                    pageNumber={opk_list.count}
                                    PageActiveItem={PageActiveItem}
                                    setPageActiveItem={setPageActiveItem}
                                    style={{margin: 'auto'}}
                                />
                        <Row className={'row-margin'} style={{alignItems: 'center'}} >
                            <Col sm={1} className='text-right'>Typ OPK:</Col>
                            <Col sm={3} className='okraglaczki'>
                                <Input
                                    value={opk_type_filter}
                                    type="select"
                                    name="select"
                                    id={`opk_type-filter`}
                                    onChange={(e) => setOpkTypeFilter(e.target.value)}
                                    aria-label={'Wybierz typ OPK'}
                                >
                                    <option value={""}>wszystkie</option>
                                    <option value={"podstawowy"}>podstawowy</option>
                                    <option value={"proceduralny"}>proceduralny</option>
                                    <option value={"pomocniczy medyczny"}>pomocniczy medyczny</option>
                                    <option value={"pomocniczy niemedyczny"}>pomocniczy niemedyczny</option>
                                    <option value={"zarząd"}>zarząd</option>
                                </Input>
                            </Col>
                        {showChangeClcSettings()&&<>
                            <Col sm={2}> </Col>
                            <Col sm={2} className='text-right'>Sposób rozliczenia kosztów zarządu:</Col>
                                <Col sm={3}>
                                    <Input
                                        value={calc_settings_select}
                                        type="select"
                                        name="select"
                                        id={`mng-clc`}
                                        onChange={(e) => setCalcSettings(e.target.value)}
                                    >
                                        <option value={""} disabled>{"nie wybrano"}</option>
                                        <option value={"koszty"}>{"według wartości kosztu wytworzenia OPK"}</option>
                                        <option value={"przychody"}>{"według wartości przychodów OPK"}</option>
                                    </Input>
                                </Col>
                                <Col sm={1}>
                                    <Button
                                        className="btn-link"
                                        color="import"
                                        data-toggle="tooltip"
                                        id={`save-clc-st`}
                                        type="button"
                                        onClick={()=>{saveClcSettings()}}
                                    >
                                        <i className="far fa-save fa-2x m-0"></i>
                                    </Button>
                                    <UncontrolledTooltip
                                        delay={0}
                                        placement="top"
                                        target={`save-clc-st`}
                                    >
                                        Zapisz
                                    </UncontrolledTooltip>
                                </Col>
                        </>}
                        </Row><br/>
                        <OPKForm opk_list={opk_list.results} group_code={group_code_5} dataSubmit={putOPK} deleteOPK={deleteOPK} notify={notify} filtered={opk_type_filter}/>
                        <PaginationButtons
                            pageNumber={opk_list.count}
                            PageActiveItem={PageActiveItem}
                            setPageActiveItem={setPageActiveItem}
                        />
                    </>
                    : <>Pobieranie danych z serwera...</>
                }
            </div>
        </>
    )
}


const mapStateToProps = (state) => ({
  GetOpk: state.GetOpk,
  currentUser: state.UserReducer.currentUser
});

export default connect(mapStateToProps,{ postOPK, getGroupCode5, getOPK, putOPK, deleteOPK, getCalcSettings, putCalcSettings })(MainOPK)
